import { TabList as MuiTabList } from '@mui/lab';
import { styled } from '@mui/material';

export const TabList = styled(MuiTabList)(() => ({
  marginTop: '64px',
}));
